import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"
import { cn } from "../utils/cn"

const Slider = React.forwardRef<
    React.ElementRef<typeof SliderPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, value, defaultValue, ...props }, ref) => {
    // determine number of thumbs from value or defaultValue
    const numThumbs = value?.length ?? defaultValue?.length ?? 1;

    return (
        <SliderPrimitive.Root
            ref={ref}
            className={cn(
                "relative flex w-full touch-none select-none items-center",
                className
            )}
            value={value}
            defaultValue={defaultValue}
            {...props}
        >
            <SliderPrimitive.Track className="relative h-2.5 w-full grow overflow-hidden rounded-sm">
                <div className="absolute left-0 right-0 top-0 bottom-0 rounded-sm border-brutal border-ink bg-background shadow-inset-soft" />
                <SliderPrimitive.Range className="absolute h-full bg-mint/90 rounded-sm" />
            </SliderPrimitive.Track>
            {Array.from({ length: numThumbs }).map((_, index) => (
                <SliderPrimitive.Thumb
                    key={index}
                    className="block h-5 w-5 rounded-sm border-brutal border-ink bg-paper shadow-brutal-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
                />
            ))}
        </SliderPrimitive.Root>
    );
})
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
